import { render } from "./PostSerialNumber.vue?vue&type=template&id=a3f2fba4&scoped=true&ts=true"
import script from "./PostSerialNumber.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostSerialNumber.vue?vue&type=script&setup=true&lang=ts"

import "./PostSerialNumber.vue?vue&type=style&index=0&id=a3f2fba4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src609605036/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3f2fba4"],['__file',"src/components/agsrs/PostSerialNumber.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a3f2fba4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a3f2fba4', __exports__)) {
    console.log('reload')
    api.reload('a3f2fba4', __exports__)
  }
  
  module.hot.accept("./PostSerialNumber.vue?vue&type=template&id=a3f2fba4&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('a3f2fba4', render)
  })

}


export default __exports__